import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Camera, Calendar } from "lucide-react";
import { api } from "../../lib/api";
import { formatDateTime } from "../../lib/utils-format";

export function StaffEventsPage() {
    const { t, i18n } = useTranslation();
    const [events, setEvents] = useState([]);
    const [loading, setLoading] = useState(true);
    const locale = i18n.language === "fr" ? "fr-FR" : i18n.language === "ht" ? "fr-FR" : "en-US";

    useEffect(() => {
        api.get("/api/my-staff-events").then(({ data }) => { setEvents(data || []); setLoading(false); });
    }, []);

    if (loading) return <div className="p-10 text-muted-foreground">{t("common.loading")}</div>;

    return (
        <div data-testid="staff-events-page" className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-10 space-y-6">
            <h1 className="font-heading font-black text-3xl md:text-4xl">{t("nav.checkin")}</h1>
            {events.length === 0 ? (
                <div className="rounded-2xl border-2 border-dashed border-border p-12 text-center text-muted-foreground">
                    No events where you are staff.
                </div>
            ) : (
                <div className="space-y-3">
                    {events.map((e) => (
                        <div key={e.id} data-testid={`staff-event-${e.id}`} className="bento-card p-5 flex items-center justify-between gap-4">
                            <div className="flex-1">
                                <h3 className="font-bold">{e.title}</h3>
                                <div className="text-xs text-muted-foreground flex items-center gap-1 mt-1">
                                    <Calendar className="h-3 w-3" />
                                    {formatDateTime(e.start_datetime, locale)}
                                </div>
                                <div className="text-xs text-muted-foreground">{e.venue?.name}</div>
                            </div>
                            <Link to={`/staff/events/${e.id}/checkin`} data-testid={`staff-checkin-${e.id}`} className="btn-primary !py-2 !px-4 text-sm inline-flex items-center gap-2">
                                <Camera className="h-4 w-4" />
                                {t("organizer.scan")}
                            </Link>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
}
